import React, { useContext, useState, useEffect } from 'react';

import { 
    Box,
    FormControl,
    FormControlLabel,
    InputLabel,
    MenuItem,
    Select,
    Switch,
    Typography, 
    TextField
} from '@mui/material';

import ProjectContext from '../../contexts/ProjectContext';
import {useFetch} from '../../components/auth/useFetch';

import DownloadButton from '../buttons/DownloadButton';
import FdlButton from '../buttons/FdlButton';
import FormField from '../formfield/FormField';
import HelpTooltip from '../popover/HelpTooltip';
import ReviewSummary from '../summary/ReviewSummary';
import ReviewTable from '../table/ReviewTable';



export default function ReviewForm(props) {
    const { style, display, cameraData, intentData, change, setCurrentForm, fdlData, setFdlData, sessionID } = props;
    const projectContext = useContext(ProjectContext);
    
    const [finalFDL, setFinalFDL] = useState('');
    const [showResults, setShowResults] = useState('none');
    const [showDownloads, setShowDownloads] = useState('none')
    const [wantSvg, setWantSvg] = useState(false);
    const [wantPdf, setWantPdf] = useState(false);
    const [wantJpg, setWantJpg] = useState(false);
    const [wantTiff, setWantTiff] = useState(false);
    const [greyscale, setGreyscale] = useState(false)
    const [borderPips, setBorderPips] = useState(false)
    const [additionalNotes, setAdditionalNotes] = useState('')
    const [downloadChartsLabel, setDownloadChartsLabel] = useState('Generating Charts')
    const [awaitActivePrereqs, setAwaitActivePrereqs] = useState(true)
    const [includeCharts, setIncludeCharts] = useState(false)
    const [starSize, setStarSize] = useState('small')
    const [chartOptionsDisabled, setChartOptionsDisabled] = useState(true)
    const [chartsButtonDisabled, setChartsButtonDisabled] = useState(true)
    const fetchWithAuth = useFetch()


    useEffect(()=>{
        setAwaitActivePrereqs(true)
        if (wantSvg || wantPdf || wantJpg || wantTiff){
            setIncludeCharts(true)
            // setDownloadChartsLabel('Generate charts again')
            setChartOptionsDisabled(false)
            chartsOptionsChange('Generate charts again')


        }else{
            setIncludeCharts(false)
            // setDownloadChartsLabel('No Chart Formats Selected')
            setChartOptionsDisabled(true)
            chartsOptionsChange('No Chart Formats Selected')

        }
    },[wantSvg, wantPdf, wantJpg, wantTiff])


    const container = {
        gridColumnStart: '1',
        gridColumnEnd: '13',
        display: display,
        ...style
    };

    const summaryBox = {

        marginTop: '20px',
        marginBottom: '50px'
    };

    const formFieldBox = {
        gridColumnStart: '1',
        gridColumnEnd: '12',
        width: '100%'
    };

    const textInput = {
        gridColumnStart: '1',
        gridColumnEnd: '12'

    };

    const submitButton = {
        width: '200px',
        height: '100px',
        background: 'rgb(63 147 89)',
    };

    const submitContainer = {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginBottom: '30px', 
        height: '260px'    
    };

    const submitButtonContainer = {
        display: 'flex',
        justifyContent: 'space-around',
        alignItems: 'center',
        height: '100%',
        width: '33%',
        backgroundColor: 'rgb(47, 93, 76)'
    };



    const framingContainer = {
        backgroundColor: 'rgb(30, 80, 60)',
        // display: 'flex',
        // display: 'grid',
        // gap: '5px',
        // gridTemplateColumns: '1fr 1fr',
        color: 'white',
        width: '66%',
        height: '100%',
        padding: '20px',
        boxSizing: 'border-box'

    }

    const framingFormatsSectionContainer = {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        border: '2px solid rgb(20, 60, 20)',
        borderRadius: '5px',
        padding: '10px',
        width: 'auto'
    }


    const framingOptionsSectionContainer = {
        // display: 'grid',
        
        border: '2px solid rgb(20, 60, 20)',
        borderRadius: '5px',
        padding: '10px'
    }
    

    const switchContainerHeading = {
        // width: '100%',
        textAlign: 'left',
        marginBlockEnd: '0.2em',
        marginBlockStart: '0.2em',
        gridColumn: '1 / 3'
    }


    const resultsStyle = {
        display: showResults,
        transition: '0.5s',
        // TODO: Gross use of a fixed height - calculate better
        height: '400px',
        overflow: 'auto',
        marginTop: '10px'
    }

    const fdlCodeStyle = {
        height: '100%',
        width: '100%'
    }


    const downloadsContainer = {
        display: showDownloads,
        gap: '10px',
    }


    const addNotesChange = (value) =>{
        chartsOptionsChange('Generate charts again')
        setAdditionalNotes(value)
    }

    const starSizeChange = (value) => {
        setStarSize(value)
        chartsOptionsChange('Generate charts again')
    }


    function chartOptionsSwitchChecked(event) {
        // Switch is 'on'
        chartsOptionsChange('Generate charts again')
        
        if (event['target']['checked'] == true) {
            switch (event['target']['id']) {
                case 'chart_option_greyscale':
                    setGreyscale(true)
                    break;
                case 'chart_option_borderpips':
                    setBorderPips(true)
                    break;

            }
        }
        // Swtich is 'off'
        else {
            switch (event['target']['id']) {
                case 'chart_option_greyscale':
                    setGreyscale(false)
                    break;
                case 'chart_option_borderpips':
                    setBorderPips(false)
                    break;
            }
        }
    }


    const chartsOptionsChange = (label) => {
        setAwaitActivePrereqs(true)
        setChartsButtonDisabled(true)
        setDownloadChartsLabel(label)

    }


    function chartSwitchChecked(event) {
        // Switch is 'on'
        if (event['target']['checked'] == true) {
            switch (event['target']['id']) {
                case 'chart_option_svg':
                    setWantSvg(true)
                    break;
                case 'chart_option_pdf':
                    setWantPdf(true)
                    break;
                case 'chart_option_jpg':
                    setWantJpg(true)
                    break;
                case 'chart_option_tiff':
                    setWantTiff(true)
                    break;
            }
        }
        // Swtich is 'off'
        else {
            switch (event['target']['id']) {
                case 'chart_option_svg':
                    setWantSvg(false)
                    break;
                case 'chart_option_pdf':
                    setWantPdf(false)
                    break;
                case 'chart_option_jpg':
                    setWantJpg(false)
                    break;
                case 'chart_option_tiff':
                    setWantTiff(false)
                    break;
            }
        }
    }








    async function handleSubmit(event) {
        event.preventDefault();
        const data = new FormData(event.currentTarget);
        let nearCompleteFDLData = JSON.parse(fdlData);
        let dataArray = [null];
       

        for (const entry of data.entries()) {
            if (entry !== undefined) {
                dataArray.push(entry[1])
            }
        };

        let splitArray = [];

        for (let i = 1; i < dataArray.length; i++) {
            if (i % 3 === 0) {
                splitArray.push([dataArray[i - 2], dataArray[i - 1], dataArray[i]])
            }
        };

        // TODO: The below solution sucks for so many reasons, I will refactor this zh
        // Look through FDL file to find the camera, then the framing decision that matches this framing decision
        for (let item in splitArray) {
            for (let canvas in nearCompleteFDLData['contexts'][0]['canvases']) {
                if (nearCompleteFDLData['contexts'][0]['canvases'][canvas]['id'] === splitArray[item][1]) {
                    // found camera
                    for (let fd in nearCompleteFDLData['contexts'][0]['canvases'][canvas]['framing_decisions']) {
                        if (nearCompleteFDLData['contexts'][0]['canvases'][canvas]['framing_decisions'][fd]['framing_intent_id'] === splitArray[item][2]) {
                            // Found framing decision
                            nearCompleteFDLData['contexts'][0]['canvases'][canvas]['framing_decisions'][fd]['label'] = splitArray[item][0]
                        }
                    }
                }
            }
        };
        setFinalFDL(JSON.stringify(nearCompleteFDLData, false, 2));
        generateCharts(nearCompleteFDLData);

        setShowResults('block');
        setShowDownloads('flex');
    };

    async function downloadFDL(event) {
        let url = URL.createObjectURL( new Blob([finalFDL] ));
        let filename = 'output.fdl'
        return {'url': url, 'filename':filename}
    };


    async function generateCharts(nearCompleteFDLData) {
        // ============ Image generation ==============
        let sessionIDString = `${sessionID}`;

        if (wantSvg || wantPdf || wantJpg || wantTiff) {
            // Disable button until the new download is ready
            chartsOptionsChange('Generating Charts')

            // Collate which formats we are requesting
            let chart_gen_formats = { 'wantSvg': wantSvg, 'wantPdf': wantPdf, 'wantJpg': wantJpg, 'wantTiff': wantTiff }

            let fetchDetails = {
                method: "POST",
                body: JSON.stringify({ 
                    "sessionID": sessionIDString, 
                    "fdl": JSON.stringify(nearCompleteFDLData), 
                    "formats": chart_gen_formats, 
                    "options": {"greyscale": greyscale, "additionalNotes": additionalNotes, "starSize": starSize, "borderPips": borderPips }
                }),
                headers: { "Content-type": "application/json; charset=UTF-8", 'X-Project-ID': projectContext?.project_db }
            };
            let request = await fetchWithAuth(`${process.env.REACT_APP_BACKEND_URL}/konsol/fdlimagegen/`, fetchDetails);

            let response = await request.text();
            setAwaitActivePrereqs(false)
            setChartsButtonDisabled(false)
            setDownloadChartsLabel('Download Charts')
        }
        else {
            chartsOptionsChange('No Chart Formats Selected')
        }
    }


    // async function downloadCharts(event) {
    //     let sessionIDString = `${sessionID}`;
    //     let fetchDetails = {
    //         method: "POST",
    //         body: JSON.stringify({ "sessionID": sessionIDString }),
    //         headers: { "Content-type": "application/json; charset=UTF-8" }
    //     };

    //     // TODO: Check if we actually receive a file - if not, DO NOT saveAS. Currently if the backend fails, we still get a non-working .zip file downloaded.
    //     let request = await fetchWithAuth(`${process.env.REACT_APP_BACKEND_URL}/konsol/fdlimagedownload/`, fetchDetails);
    //     let response = await request;
    //     const blob = await response.blob();
    //     saveAs(blob, 'test.zip');


    // };

    async function downloadFDL(event) {
        let url = URL.createObjectURL( new Blob([finalFDL] ));
        let filename = 'output.fdl'
        return {'url': url, 'filename':filename}
    };

    async function downloadCharts () {
        let initial_url = `${process.env.REACT_APP_BACKEND_URL}/konsol/fdlimagedownload/`;
        let response = await fetchWithAuth(initial_url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json', 'X-Project-ID': projectContext?.project_db
            }
        })
        let blob = await response.blob()
        let status = response.status

        
        let url = window.URL.createObjectURL(blob);
        const filename = `charts.zip`
        // Return essential data to calling function 
        return {'url': url, 'filename':filename, 'status': status}
    }



    if ((cameraData !== undefined || cameraData !== null) && (intentData !== undefined || intentData !== null)) {
        return (
            <div style={container}>
                <h2 style={{marginTop:'0px'}}>
                    Finalise Framing Decisions
                    <HelpTooltip 
                        text="Label each framing decision generated and export your final .FDL file and graphic charts." 
                    />
                    
                </h2>
                <Box component='form' onSubmit={handleSubmit}
                    style={formFieldBox}
                    autoComplete='off'
                >
                    {Object.keys(cameraData).map((cameraName) => (
                        Object.keys(intentData).map((intentName) => (
                            // <div key={cameraName}>
                            <div>
                                <Typography variant='h8' color={'white'}>Camera ID: </Typography>
                                <Typography variant='h8' color={'silver'}>{cameraData[cameraName]['Camera ID']}</Typography><br></br>
                                <Typography variant='h8' color={'white'}>Intent ID: </Typography>
                                <Typography variant='h8' color={'silver'}>{intentData[intentName]['Intent ID']}</Typography>
                                {/* <div key={intentName} style={summaryBox}> */}
                                <div style={summaryBox}>

                                    <FormField
                                        name='Framing Decision Label'
                                        label='Framing Decision Label'
                                        fontSize='10px'
                                        units=''
                                        placeholder=''
                                        style={textInput}
                                        required
                                        toolTip="Enter a name for this Framing Decision"
                                    />
                                    <input type='hidden' name='camera' value={cameraData[cameraName]['Camera ID']} />
                                    <input type='hidden' name='intent' value={intentData[intentName]['Intent ID']} />

                                    {/* FDl Data goes here */}
                                    <ReviewSummary
                                        fdlData={fdlData}
                                        cameraID={cameraData[cameraName]['Camera ID']}
                                        intentID={intentData[intentName]['Intent ID']}
                                    >
                                        <ReviewTable
                                        intentName={intentName}
                                        intentDetails={intentData[intentName]}
                                        cameraDetails={cameraData[cameraName]}
                                    />
                                    </ReviewSummary> 
                                </div>
                            </div>
                        ))
                    ))}
                    <hr></hr>
                    <h3>Output</h3>
                    <div style={submitContainer}>
                        <Box style={submitButtonContainer}>
                            <FdlButton type='submit' text={`Generate .FDL ${includeCharts ? '+ charts' : ''}`} style={submitButton}></FdlButton>
                        </Box>
                        <div style={framingContainer}>
                            <h4 style={switchContainerHeading}>Framing Charts</h4>
                            <Box style={{display:'flex', gap: '20px'}}>
                            <Box style={framingFormatsSectionContainer}>
                                <h5 style={switchContainerHeading}>Formats</h5>
                                <FormControlLabel control={<Switch onClick={chartSwitchChecked} color="warning" id="chart_option_svg" />} labelPlacement="start" label="SVG" />
                                <FormControlLabel control={<Switch onChange={chartSwitchChecked} color="warning" id="chart_option_tiff" />} labelPlacement="start" label="TIFF" />
                                <FormControlLabel control={<Switch onChange={chartSwitchChecked} color="warning" id="chart_option_pdf" />} labelPlacement="start" label="PDF" />
                                <FormControlLabel control={<Switch onChange={chartSwitchChecked} color="warning" id="chart_option_jpg" />} labelPlacement="start" label="JPG" />
                            </Box>
                                <Box 
                                    style={framingOptionsSectionContainer} 
                                    bgcolor={chartOptionsDisabled ? 'rgb(20, 70, 50)' : "inherit"}
                                >
                                <h5 style={switchContainerHeading}>Options</h5>
                                    <Box 
                                        display='grid'
                                        gridTemplateColumns="1fr 1fr"
                                        gridTemplateRows="1fr 1fr"
                                        justifyItems='start'
                                        alignItems='start'

                                    >
                                        <FormControlLabel control={<Switch onClick={chartOptionsSwitchChecked} color="warning" id="chart_option_greyscale" disabled={chartOptionsDisabled} />} labelPlacement="start" label="Greyscale" />
                                        <FormControlLabel control={<Switch onClick={chartOptionsSwitchChecked} color="warning" id="chart_option_borderpips" disabled={chartOptionsDisabled} />} labelPlacement="start" label="Frame pips" />

                                        <FormControl sx={{width: '100%'}} >
                                            <InputLabel id="star-size-label">Siemens Star Size</InputLabel>
                                            <Select labelId="star-size-label" label="Siemens Star Size" disabled={chartOptionsDisabled} value={starSize} onChange={(event) => starSizeChange(event.target.value)}>
                                                <MenuItem value={'small'}>Small</MenuItem>
                                                <MenuItem value={'med'}>Med</MenuItem>
                                                <MenuItem value={'large'}>Large</MenuItem>
                                                <MenuItem value={'xlarge'}>Huge</MenuItem>
                                            </Select>
                                        </FormControl>

                                        <TextField
                                            label="Extra notes"
                                            onChange={(event)=> addNotesChange(event.target.value) }
                                            sx={{ input: { color: 'white' } }}
                                            variant="outlined"
                                            disabled={chartOptionsDisabled}
                                            inputProps={{ maxLength: 32 }}
                                        />
                                    </Box>
                                </Box>
                            </Box>
                        </div>
                    </div>
                </Box>
                
                <Box style={downloadsContainer}>
                    <DownloadButton                   
                        hoverColor='white'
                        color='silver'
                        dlButtonType='button'
                        buttonText='Download .FDL'
                        iconOnly = {false}
                        downloadParams = {() => downloadFDL()}

                    />
                    <DownloadButton
                        downloadParams = {() => downloadCharts()}
                        hoverColor='white'
                        color='silver'
                        iconOnly = {false}
                        buttonText={downloadChartsLabel}
                        setButtonText={setDownloadChartsLabel}
                        defaultButtonText={'Download Charts'}
                        awaitActivePrerequisites={awaitActivePrereqs}
                        setAwaitActivePrerequisites={setAwaitActivePrereqs}
                        forceDisabled={chartsButtonDisabled}
                    />
                </Box>
                <Box style={resultsStyle} sx={{
                    marginTop: '40px',
                    backgroundColor: 'white',
                    padding: '20px',
                    borderRadius: '10px',
                    color:'black',
                    height: '100%'
                }}>
                    <pre style={fdlCodeStyle}>{finalFDL}</pre>
                </Box>
            </div>
        );
    } else {
        return (<div></div>)
    };
};